var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"flex-row text-center ml-n8"},[_c('v-col',{staticClass:"mx-auto",attrs:{"cols":"12","sm":"12","md":"12"}},[_c('h1',{staticClass:"btnAzul--text text-h4 font-weight-bold break-word"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }